import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SCHEDULE_DATE_DETAIL = 'GET_SCHEDULE_DATE_DETAIL';
export const GET_SCHEDULE_DATE_DETAIL_SUCCESS =
  'GET_SCHEDULE_DATE_DETAIL_SUCCESS';
export const GET_SCHEDULE_DATE_DETAIL_FAILURE =
  'GET_SCHEDULE_DATE_DETAIL_FAILURE';

// Action Creators
export const getScheduleDateDetail = () => ({
  type: GET_SCHEDULE_DATE_DETAIL,
});

export const getScheduleDateDetailSuccess = (users) => ({
  type: GET_SCHEDULE_DATE_DETAIL_SUCCESS,
  payload: users,
});

export const getScheduleDateDetailFailure = (error) => ({
  type: GET_SCHEDULE_DATE_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getScheduleDateDetailCallAPI = (external, doctorId, date) => {
  return async (dispatch) => {
    dispatch(getScheduleDateDetail());
    try {
      const response = await getMethodWithToken(
        url?.getScheduleDetail + '?doctor_id=' + doctorId + `&date=${date}`
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getScheduleDateDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getScheduleDateDetailFailure(error?.message));
    }
  };
};
